import { ArrowDown } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { useI18n } from "@/lib/i18n";

export default function Hero() {
    const { t } = useI18n();
    const scrollTo = (id) => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <section
            id="home"
            data-testid="hero-section"
            className="relative min-h-screen w-full overflow-hidden flex items-center justify-center grain"
        >
            <div
                className="absolute inset-0 bg-cover bg-center scale-105"
                style={{ backgroundImage: `url(${BRAND.hero})` }}
                aria-hidden
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#050D1C]/85 via-[#050D1C]/70 to-[#050D1C]" aria-hidden />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,#050D1C_85%)]" aria-hidden />

            <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12 text-center pt-28 pb-24">
                <div className="reveal flex items-center justify-center mb-10">
                    <img
                        src={BRAND.logo}
                        alt="LuxeNova logo"
                        className="h-32 w-32 md:h-40 md:w-40 rounded-full object-cover ring-1 ring-[#C9A96E]/40 shadow-[0_20px_60px_rgba(0,0,0,0.55)]"
                    />
                </div>

                <div className="reveal mb-6">
                    <span className="eyebrow">
                        <span className="gold-divider mr-4" />
                        {t("hero.eyebrow")}
                        <span className="gold-divider ml-4" />
                    </span>
                </div>

                <h1
                    data-testid="hero-headline"
                    className="reveal font-serif-display text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.05] tracking-tight max-w-5xl mx-auto"
                >
                    {t("hero.title_a")} <br className="hidden md:block" />
                    <em className="not-italic text-[#C9A96E]">{t("hero.title_highlight")}</em> {t("hero.title_b")}
                </h1>

                <p
                    data-testid="hero-subheadline"
                    className="reveal mt-8 max-w-2xl mx-auto text-base sm:text-lg text-slate-300/90 font-light leading-relaxed"
                >
                    {t("hero.subheadline")}
                </p>

                <div className="reveal mt-12 flex flex-col sm:flex-row gap-4 items-center justify-center">
                    <button data-testid="hero-cta-primary" onClick={() => scrollTo("#contact")} className="btn-gold">
                        {t("hero.cta_primary")}
                    </button>
                    <button data-testid="hero-cta-secondary" onClick={() => scrollTo("#services")} className="btn-ghost-gold">
                        {t("hero.cta_secondary")}
                    </button>
                </div>
            </div>

            <button
                data-testid="hero-scroll-cue"
                onClick={() => scrollTo("#about")}
                className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#C9A96E]/70 hover:text-[#C9A96E] transition floaty"
                aria-label="Scroll down"
            >
                <ArrowDown size={22} />
            </button>
        </section>
    );
}
